import React from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

/**
 * Carries each new page in rather than swapping it instantly.
 *
 * Route groups prevent unmounting/re-animating the whole layout when
 * switching tabs or sub-routes within the same section (e.g. Doctor Workspace,
 * Patient Dashboard, LMS).
 */
export default function PageTransition({ children }) {
  const { pathname } = useLocation();

  const getRouteGroup = (path) => {
    if (path.startsWith('/doctor')) return '/doctor';
    if (path.startsWith('/dashboard')) return '/dashboard';
    if (path.startsWith('/lms') || path.startsWith('/student')) return '/lms';
    return path;
  };

  const routeGroup = getRouteGroup(pathname);

  return <div key={routeGroup} className="dp-page">{children}</div>;
}
